export { default } from './ModalDeleteCofirm';
